import {
    GET_ALL_INVOICES,
    GET_SINGLE_INVOICE,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './returnTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_INVOICES:
            return {
                ...state,
                all_invoices: action.payload,
            }
        case GET_SINGLE_INVOICE:
            return {
                ...state,
                single_invoice: action.payload,
            }

        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
